import CriticalError from './CriticalError';

export default CriticalError;
